import fetch from './AxiosAdapter';
import Configuracao from '../misc/Configuracao';
import UsuarioStore from '../store/UsuarioStore';

class MinutaDevolvidaApi {
    async countMinutasDevolvidas(): Promise<number> {
        const result = await fetch<number>(Configuracao.urlCountMinutasDevolvidas.replace('{gabinete}', UsuarioStore.gabinete));
        return result.data;
    }
}

export default new MinutaDevolvidaApi();